import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../context/context'
import HomeChecklist from '../layout/home_checlikst';
import UiSpinner from '../components/ui_spinner';

const Home = () => {

    const {
        fetchDataV2,
        neonUser,
        ww,
    } = useContext(AppContext)

    const [checklist, setChecklist] = useState({})
    const [loading, setLoading] = useState(false)

    const createChecklist = async () => {
        let query2 = "CREATE_CHECKLIST", params2 = [neonUser.user_id]
        await fetchDataV2(query2, params2, "/neon-query-v2")
        getChecklist()
        return
    }

    const getChecklist = async () => {
        setLoading(true)
        let query1 = "GET_CHECKLIST", params1 = [neonUser.user_id]
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
        if (resp.length == 0) {
            createChecklist()
            setLoading(false)
            return
        }
        setChecklist(resp[0])
        setLoading(false)
        return
    }

    useEffect(() => {
        if (neonUser.user_id) getChecklist()
    }, [neonUser])

    return (
        <div style={{ maxWidth: 1200 }}>
            <div className={" d-flex flex-column gap-3 " + (ww < 400 ? "px-1 pt-4" : "p-4")}>
                <p className="fs-4 mb-1">Checklist to Install</p>
                <div className={"container1 pb-4" + (ww < 400 ? "px-2" : "")}>
                    {loading ?
                        <UiSpinner />
                        :
                        "id" in checklist ?
                            <HomeChecklist listProps={checklist} />
                            :
                            <p className='poppins text-secondary'>No checklist</p>
                    }
                </div>
            </div>
        </div>
    )
}

export default Home